module.exports = __webpack_public_path__ + "img/logo-mesguen.886c3cd7.jpg";